export default ({
  filterProp, placeholder,
}) => ({
  type: 'filter-plain-text',
  filterProp,
  attrs: {
    placeholder,
  },
});
